module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/merrill.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/merrill.png
// module id = 1171
// module chunks = 0